// * Import 3rd party lib
import React from "react";

// * Import lib comp
import { Box } from "@mui/material";
import { useTheme } from "@emotion/react";
import { makeStyles } from "@mui/styles";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import AppsRoundedIcon from "@mui/icons-material/AppsRounded";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import Typography from "../../kit/Typography";

// * Utils

// # Static variables
export const ViewTypes = {
  TABLE_VIEW: "table-view",
  SMALL_VIEW: "small-view",
  MEDIUM_VIEW: "medium-view",
};

// # Styles
const useStyles = makeStyles((theme) => ({
  viewSettingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `${theme.size[1]} solid ${theme.palette.tertiary.lightGrey}`,
    borderRadius: theme.size[10],
    width: "125px",
  },
  viewSettingIcon: {
    margin: theme.size[1],
    color: theme.palette.tertiary.lightGrey,
    fontSize: theme.size[25],
    width: theme.size[35],
    borderRadius: theme.size[4],
    height: theme.size[25],
    padding: theme.size[3],
    "&:hover": {
      cursor: "pointer",
    },
  },
  viewSettingIconActive: {
    backgroundColor: `${theme.palette.tertiary.darkBlue} !important`,
    color: theme.palette.viewIcon.active,
  },
  viewSettingIconInctive: {
    color: `${theme.palette.viewIcon.main} !important`,
  },
  viewSettingIconInctiveFilled: {
    color: `${theme.palette.secondary.main} !important`,
  },
  viewSettingIconDisable: {
    pointerEvents: "none",
    opacity: "0.5",
  },
}));

// # Component
function ViewSetting(props = {}) {
  // * Props
  const { currentView, disabled, showName, handleViewChange } = props;

  // * Hooks
  const theme = useTheme();
  const classes = useStyles(theme);

  // # JSX
  return (
    <Box
      id={"explore-viewby"}
      sx={{
        display: "flex",
        margin: "0px 10px",
        borderRadius: theme.size[3],
        alignItems: "center",
        height: theme.size[40],
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <GridViewRoundedIcon
          sx={{
            height: theme.size[18],
            width: theme.size[18],
            border: showName ? `1px solid ${theme.palette.secondary.main}` : "",
          }}
          onClick={() => handleViewChange(ViewTypes.MEDIUM_VIEW)}
          className={`material-symbols-rounded filled ${
            classes.viewSettingIcon
          } ${
            ViewTypes.MEDIUM_VIEW === currentView
              ? classes.viewSettingIconActive
              : showName
              ? classes.viewSettingIconInctiveFilled
              : classes.viewSettingIconInctive
          }
        ${disabled && classes.viewSettingIconDisable}
        `}
        />
        {showName && (
          <Typography
            sx={{
              margin: "0px 20px",
              fontSize: theme.size[12],
              color: theme.palette.primary.darkViolet,
              fontWeight: theme.fontWeight[500],
              textTransform: "capitalize",
            }}
          >
            {ViewTypes.MEDIUM_VIEW}
          </Typography>
        )}
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <AppsRoundedIcon
          sx={{
            height: theme.size[20],
            width: theme.size[20],
            border: showName ? `1px solid ${theme.palette.secondary.main}` : "",
          }}
          onClick={() => handleViewChange(ViewTypes.SMALL_VIEW)}
          className={`material-symbols-rounded filled ${
            classes.viewSettingIcon
          } ${
            ViewTypes.SMALL_VIEW === currentView
              ? classes.viewSettingIconActive
              : showName
              ? classes.viewSettingIconInctiveFilled
              : classes.viewSettingIconInctive
          }
        ${disabled && classes.viewSettingIconDisable}
        `}
        />
        {showName && (
          <Typography
            sx={{
              margin: "0px 20px",
              fontSize: theme.size[12],
              color: theme.palette.primary.darkViolet,
              fontWeight: theme.fontWeight[500],
              textTransform: "capitalize",
            }}
          >
            {ViewTypes.SMALL_VIEW}
          </Typography>
        )}
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <ViewListRoundedIcon
          sx={{
            height: theme.size[24],
            width: theme.size[24],
            border: showName ? `1px solid ${theme.palette.secondary.main}` : "",
            color: theme.palette.secondary.main,
          }}
          onClick={() => handleViewChange(ViewTypes.TABLE_VIEW)}
          className={`material-symbols-rounded filled ${
            classes.viewSettingIcon
          } ${
            ViewTypes.TABLE_VIEW === currentView
              ? classes.viewSettingIconActive
              : showName
              ? classes.viewSettingIconInctiveFilled
              : classes.viewSettingIconInctive
          }
        ${disabled && classes.viewSettingIconDisable}
        `}
        />
        {showName && (
          <Typography
            sx={{
              margin: "0px 20px",
              fontSize: theme.size[12],
              color: theme.palette.primary.darkViolet,
              fontWeight: theme.fontWeight[500],
              textTransform: "capitalize",
            }}
          >
            {ViewTypes.TABLE_VIEW}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

// # Exports
export default ViewSetting;
